import { Component, OnInit } from '@angular/core';
import { PickupCardService } from '../service/pickup-card.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-pickupcards',
  templateUrl: './pickupcards.component.html'
})
export class PickupcardsComponent implements OnInit {
  SitePickups: any;
  image: string;
  constructor(  private dataApi: PickupCardService,
                private spinner: NgxSpinnerService,
                public dialog: MatDialog,
                private _snackBar: MatSnackBar,) { }

  ngOnInit() {

    this.spinner.show("loading");
    this.dataApi.getPickupsCards()
      .subscribe((data: any) => {
        this.SitePickups = data;
        this.spinner.hide("loading");
      }, (err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      }
      );

  }
  getlang(){

    return sessionStorage.getItem('lang');
  }
  PushImage(indexSite, indexPickup) {
    this.spinner.show("loading");
    if(this.SitePickups[indexSite].pickups[indexPickup]){
      if(this.SitePickups[indexSite].pickups[indexPickup].image) {
        this.SitePickups[indexSite].pickups[indexPickup].show= !this.SitePickups[indexSite].pickups[indexPickup].show;
        this.spinner.hide("loading");
      } else {
        this.dataApi.getPickupImage(this.SitePickups[indexSite].id, this.SitePickups[indexSite].pickups[indexPickup].id)
          .subscribe((data: any) => {
            Object.assign(this.SitePickups[indexSite].pickups[indexPickup],{
              image: data.image,
              show: true
            });
            this.spinner.hide("loading");
          }, (err) => {
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',
              });
            }
          }
          );

      }
    }else{
      this._snackBar.open('Pickup not found', '', {
        duration: 3000,
      });
    }
  }

  // getImage(siteId, pickupId){

  // }
}
